/* The footer. A deep-blue field, the wordmark set large in the accent, and four
 * columns of where-to-next. Only real station profiles and the real contact
 * address are listed here; guest artists' platforms belong on their pages. */

import { Link } from 'react-router-dom';

export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterProps {
  /** Override the station's known profiles in an embedded build. */
  elsewhere?: FooterLink[];
  /** Override the station's public contact address in an embedded build. */
  email?: string;
  className?: string;
}

const STATION_PROFILES: FooterLink[] = [
  { label: 'Instagram', href: 'https://www.instagram.com/highergroundradio/' },
  { label: 'SoundCloud', href: 'https://soundcloud.com/highergroundradio' },
];
const STATION_EMAIL = 'highergroundradioshow@gmail.com';

export function Footer({ elsewhere = STATION_PROFILES, email = STATION_EMAIL, className }: FooterProps) {
  return (
    <footer className={className ? `foot ${className}` : 'foot'}>
      <div className="foot__mark">
        <span className="wordmark foot__wordmark">
          Higher Ground
          <br />
          Radio
        </span>
        <p className="mono foot__strap">
          Amsterdam · est. 2018 · scheduled shows, permanent archive
        </p>
      </div>

      <div className="foot__col">
        <h4>Station</h4>
        <ul>
          <li>
            <Link to="/schedule">Schedule</Link>
          </li>
          <li>
            <Link to="/archive">Archive</Link>
          </li>
          <li>
            <Link to="/residents">Higher Ground Rhythm Police</Link>
          </li>
        </ul>
      </div>

      <div className="foot__col">
        <h4>Take part</h4>
        <ul>
          <li>
            <Link to="/submit">Submit a set</Link>
          </li>
          <li>
            <Link to="/submit">Apply for a residency</Link>
          </li>
        </ul>
      </div>

      <div className="foot__col">
        <h4>Elsewhere</h4>
        <ul>
          {elsewhere.map((link) => (
            <li key={link.href}>
              <a href={link.href} rel="me noreferrer" target="_blank">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="foot__col">
        <h4>Contact</h4>
        <ul>
          <li>
            <a href={`mailto:${email}`}>
              {email}
              <span className="vh"> — contact Higher Ground Radio</span>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
